import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiUrlHelper } from 'src/app/common/api-url-helper';
import { CommonService } from 'src/app/services/common/common.service';
import { SessionPassDialogComponent } from '../session-pass-dialog/session-pass-dialog.component';
import { SessionDetailDialogComponent } from '../session-detail-dialog/session-detail-dialog.component';
import { ViewMoreSessionDialogComponent } from '../view-more-session-dialog/view-more-session-dialog.component';
import { DatePipe } from '@angular/common';
import { MatDateRangePicker } from '@angular/material/datepicker';
import { dateformat } from 'src/app/models/commonModel';

@Component({
    selector: 'app-add-session-dialog',
    templateUrl: './add-session-dialog.component.html',
    styleUrls: ['./add-session-dialog.component.scss'],
    standalone: false
})
export class AddSessionDialogComponent implements OnInit {

  // Common Properties
  customerId: any;
  sessionList: any = [];
  fromDate: any;
  toDate: any;
  searchStr: string = '';
  currentDay: any;
  dateFormat: any;
  isUpcomingSessionAvailable: boolean = true;
  isSessionAvailable: boolean = false;
  isDateSelected: boolean = true;

  constructor(
    private dialogRef: MatDialogRef<AddSessionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonService: CommonService,
    private spinner: NgxSpinnerService,
    private api: ApiUrlHelper,
    private dialog: MatDialog,
    private datePipe: DatePipe) {
    this.customerId = data.customerId;
  }

  ngOnInit(): void {
    this.fromDate = new Date();
    this.toDate = new Date();
    this.toDate.setDate(this.toDate.getDate() + 30);
    this.fetchSessionList();
    this.currentDay = new Date();
    this.dateFormat = dateformat
  }

  cancel() {
    this.dialogRef.close(false);
  }

  addPass(classSessionData: any) {
    const dialogRef = this.dialog.open(SessionPassDialogComponent, {
      width: '700px',
      disableClose: true,
      autoFocus: false,
      data: {
        customerId: this.customerId,
        classSessionData: classSessionData
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == false) {
      }
      else {
        this.dialogRef.close(result);
      }
    });
  }

  viewDescription(description: any) {
    const dialogRef = this.dialog.open(SessionDetailDialogComponent, {
      width: '700px',
      disableClose: true,
      autoFocus: false,
      data: {
        description: description,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  viewMoreSession(sessionDay: any) {
    const dialogRef = this.dialog.open(ViewMoreSessionDialogComponent, {
      width: '700px',
      disableClose: true,
      autoFocus: false,
      data: {
        sessionDay: sessionDay,
        customerId: this.customerId
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == false) {
      }
      else {
        this.dialogRef.close(result);
      }
    })
  }

  fetchSessionList() {
    this.sessionList = [];
    if (this.fromDate && this.toDate) {
      let api = this.api.apiUrl.Class.GetUpcomingSessionForCustomer;
      let upcomingSessionModel;
      if (this.datePipe.transform(this.fromDate, 'dd/MM/yyyy') == this.datePipe.transform(new Date(), 'dd/MM/yyyy')) {
        upcomingSessionModel = {
          StartDate: this.formatDateTime(new Date(this.fromDate).toString(), this.datePipe.transform(new Date(), 'hh:mm a').toString()),
          EndDate: this.formatDateTime(new Date(this.toDate).toString(), '11:59 PM'),
          CustomerId: this.customerId,
          SearchText: this.searchStr,
          OffSet: this.commonService.getTimeZone()
        };
      }
      else {
        upcomingSessionModel = {
          StartDate: this.formatDateTime(new Date(this.fromDate).toString(), '12:00 AM'),
          EndDate: this.formatDateTime(new Date(this.toDate).toString(), '11:59 PM'),
          CustomerId: this.customerId,
          SearchText: this.searchStr,
          OffSet: this.commonService.getTimeZone()
        };
      }
      if (
        upcomingSessionModel.EndDate == null ||
        upcomingSessionModel.EndDate == ""
      ) {
        upcomingSessionModel.EndDate = this.fromDate;
      }
      this.spinner.show();
      this.commonService.doPost(api, upcomingSessionModel).pipe().subscribe({
        next: (response) => {
          if (response.success) {
            if (this.searchStr == '' && response.data.sessionLists.length == 0) {
              this.isUpcomingSessionAvailable = false
            }
            else {
              this.isUpcomingSessionAvailable = true
            }
            this.sessionList = response.data.sessionLists;
            this.isSessionAvailable = response.data.isSessionAvailable;
            const dayOrder = [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
              "Sunday",
            ];
            // Sort the upcomingSessionList based on the dayOrder
            this.sessionList.sort((a, b) => {
              return (
                dayOrder.indexOf(a.sessionDay) - dayOrder.indexOf(b.sessionDay)
              );
            });
            this.spinner.hide();
          } else {
            this.spinner.hide();
          }
        },
        error: (err) => {
          this.spinner.hide();
        }
      });
    }
  }

  formatDateTime(dateString: string, timeString: string): string {
    const date = new Date(dateString);
    const timeParts = timeString.split(":");
    let hours = parseInt(timeParts[0]);
    const minutes = parseInt(timeParts[1].split(" ")[0]);
    const meridian = timeParts[1].split(" ")[1];
    if (meridian === "PM" && hours !== 12) {
      hours += 12;
    } else if (meridian === "AM" && hours === 12) {
      hours = 0;
    }
    date.setHours(hours, minutes);
    const formattedDateTime = this.datePipe.transform(date, 'yyyy-MM-ddTHH:mm:ss.SSS');
    return formattedDateTime;
  }

  openPicker(picker: MatDateRangePicker<Date>) {
    picker.open();
  }

  onDateRangeChange(event: any) {
    this.fetchSessionList();
  }

  applyFilter(event) {
    if ((event.target.value == '') || (event.key && event.key === "Enter" && event.target.value != '')) {
      this.fetchSessionList();
    }
  }

  clearSearch() {
    this.searchStr = '';
    this.fetchSessionList();
  }
}